/// <amd-module name="Widgets/SDKWidget/SampleWidget" />
import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { VisualTitle } from "Reporting/Visuals/VisualTitle";
import { VssComponent } from "VSS/Platform/Layout";

export interface SampleWidgetState {}

export class SampleWidget extends VssComponent<WidgetProps, SampleWidgetState> {
    public static readonly componentType = "sampleWidget";

    constructor(props: WidgetProps) {
        super(props);
        this.state = {};
    }

    public async componentDidMount() {
        this.props.onWidgetLoaded(); // This method must be called, in order for a Widget Host to "raise the curtain", and allow a widget to become visible.
    }

    public render(): JSX.Element {
        return (
            <div className="sample-widget">
                <VisualTitle text={this.props.name} />
                Welcome to the sample Widget!
            </div>
        );
    }
}

VssComponent.register(SampleWidget.componentType, SampleWidget);
